var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"title":"Users on Paid Tariffs"}},[_c('users-paid-tariffs-all')],1)}
var staticRenderFns = []

export { render, staticRenderFns }